import { useSelector } from "app/hooks";
import {
  getCustomStartDateBounds,
  isCustomStartDateValid,
} from "helpers/reportingPeriod";
import { useEffect } from "react";
import { logAnalyticsEvent } from "services/analytics";

export const useReportingPeriodScreen = () => {
  const { selectedFunds, reportingPeriod, isCustomPeriod, customStartDate } =
    useSelector((state) => state.investmentFunds);
  const { product } = useSelector((state) => state.investmentDetails);
  const { minStartDate, maxStartDate } =
    getCustomStartDateBounds(selectedFunds);
  const continuteButtonDisabled = isCustomPeriod
    ? !isCustomStartDateValid(customStartDate, minStartDate, maxStartDate)
    : reportingPeriod === undefined;
  const continueUrl = continuteButtonDisabled ? "" : "/customisereport";
  const redirectHome = !product;

  useEffect(() => {
    logAnalyticsEvent({
      category: "Report details",
      action: "Page 2",
      label: "Display",
    });
  }, []);

  const handleContinue = () => {
    logAnalyticsEvent({
      category: "Report details",
      action: "Page 2",
      label: "Continue button",
    });
  };

  const handleBack = () => {
    logAnalyticsEvent({
      category: "Report details",
      action: "Page 2",
      label: "Back button",
    });
  };

  return {
    reportingPeriod,
    continueUrl,
    continuteButtonDisabled,
    redirectHome,
    handleContinue,
    handleBack,
  };
};
